export const toggleCheckboxState = (itemsData, documentId) =>
  itemsData?.map((item) => {
    if (item.id === documentId) {
      if (!item.checkboxContent?.length) {
        return { ...item, checked: !item.checked };
      }

      return {
        ...item,
        checked: !item.checked,
        checkboxContent: item.checkboxContent.map((subItem) => ({
          ...subItem,
          checked: !item.checked,
        })),
      };
    }

    if (item.checkboxContent?.length) {
      const updatedSublist = item.checkboxContent.map((subItem) => ({
        ...subItem,
        checked: subItem.id === documentId ? !subItem.checked : subItem.checked,
      }));
      const isAnySubItemChecked = updatedSublist.some(
        (subItem) => subItem.checked,
      );
      return {
        ...item,
        checkboxContent: updatedSublist,
        checked: isAnySubItemChecked,
      };
    }

    return item;
  });
